import { Field, FieldArray, Form, Formik, isEmptyArray } from 'formik';
import { useEffect, useState } from 'react';
import Modal from '../../../SharedComponents/Modal';
import PlusCircle from '../../../SharedComponents/Svg/PlusCircle';
import React, { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Loading from '../../../SharedComponents/Loading';
import { addForm, getLanguages, addFormQuestion } from '../ApiForms';
import FieldType from '../Components/FieldType';
import { useTranslation } from 'react-i18next';
import LanguageList from '../../../SharedComponents/LanguageList';

export default function CreateField(props) {
  const [isOpen, setIsOpen] = useState(false);
  const { id } = props.id ? props : 1;
  const { typeId, formId } = props;
  const { t, i18n } = useTranslation();
  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`bg-lightgreen space-x-1 ${
          i18n.language === 'en' ? '' : 'space-x-reverse'
        } text-sm font-bold text-white flex items-center hover:bg-lightgreenhover shadow  px-4 py-2 rounded transition duration-300 ease-in-out`}
      >
        <PlusCircle className="w-5 h-5" /> <span>{t('Create Field')}</span>
      </button>

      {isOpen && <ModalContainer id={id} typeId={typeId} isOpen={isOpen} setIsOpen={setIsOpen} formId={formId} />}
    </>
  );
}

const ModalContainer = (props) => {
  const { isOpen, setIsOpen, formId } = props;
  const [languageId, setLanguageId] = useState(1);
  const { t, i18n } = useTranslation();
  // Query Data To Fetch Languages
  const { data, isLoading, isError } = useQuery('languages', getLanguages, {
    staleTime: 360000000,
  });
  useEffect(() => {
    setLanguageId(data?.data.sort((a, b) => (a.orderNum > b.orderNum ? 1 : -1))[0].id);
  }, [data]);

  const frmQuestionLngs = data?.data?.map((language) => ({
    languageId: language.id,
    title: '',
    description: '',
    placeholderText: '',
  }));
  const initialValues = {
    formId,
    qtypeId: 1,
    frmQuestionLngs: frmQuestionLngs,
    name: 'default',
  };
  const queryClient = useQueryClient();
  // Mutate Data to Create New Page
  const mutation = useMutation(addFormQuestion, {
    onSuccess: async (data) => {
      if (data.isDone) {
        queryClient.invalidateQueries(['formQuestion']);

        setIsOpen(false);
      }
    },
  });

  const onSubmit = async (e) => {
    const newData = {
      ...e,
      qtypeId: parseInt(e.qtypeId),
      formId: parseInt(e.formId),
    };
    try {
      await mutation.mutate(newData);
    } catch (error) {
//       console.log('error', error);
    }
  };

  return (
    <>
      {data && data.data && (
        <Formik onSubmit={onSubmit} initialValues={initialValues}>
          {({ values, setFieldValue }) => {
            return (
              <Form>
                <Modal isOpen={isOpen} setIsOpen={setIsOpen} onSubmit={onSubmit} title={t('Create Field')} add={true}>
                  {isLoading && <Loading />}
                  {isError && 'error'}
                  {data && (
                    <LanguageList
                      className="flex transform translate-y-1 relative z-10 mb-4"
                      languages={data?.data}
                      languageId={languageId}
                      setLanguageId={setLanguageId}
                    >
                      <hr className="border w-full absolute bottom-0 left-0 z-0" />
                    </LanguageList>
                  )}

                  {values &&
                    values.frmQuestionLngs &&
                    values?.frmQuestionLngs.map((form, index) => (
                      <FieldArray
                        key={index}
                        name="frmQuestionLngs"
                        render={(arrayHelpers) => (
                          <>
                            {languageId === form.languageId && (
                              <>
                                <label>
                                  <b
                                    className={`font-semibold block ${
                                      i18n.language === 'en' ? '' : 'text-right'
                                    } text-gray-700`}
                                  >
                                    {t('Title')}
                                  </b>
                                  <Field
                                    className="border rounded  w-full mb-4 p-1"
                                    type="text"
                                    name="title"
                                    name={`frmQuestionLngs[${index}].title`}
                                  />
                                </label>
                                <label>
                                  <b
                                    className={`font-semibold block ${
                                      i18n.language === 'en' ? '' : 'text-right'
                                    } text-gray-700`}
                                  >
                                    {t('Description')}
                                  </b>
                                  <Field
                                    className={`border rounded  w-full mb-4 p-1`}
                                    name={`frmQuestionLngs[${index}].description`}
                                    type="text"
                                  />
                                </label>
                                <label>
                                  <b
                                    className={`font-semibold block ${
                                      i18n.language === 'en' ? '' : 'text-right'
                                    } text-gray-700`}
                                  >
                                    {t('Placeholder')}
                                  </b>
                                  <Field
                                    className="border rounded  w-full mb-4 p-1"
                                    type="text"
                                    name="title"
                                    name={`frmQuestionLngs[${index}].placeholderText`}
                                  />
                                </label>
                              </>
                            )}
                          </>
                        )}
                      />
                    ))}
                  <label>
                    <b className={`font-semibold block ${i18n.language === 'en' ? '' : 'text-right'} text-gray-700`}>
                      {t('inputName')}
                    </b>
                    <Field className="border rounded  w-full mb-4 p-1" type="text" name={`inputName`} />
                  </label>
                  <FieldType fieldName="qtypeId" />
                </Modal>
              </Form>
            );
          }}
        </Formik>
      )}
    </>
  );
};
